import { filterSupportedQueryFields } from '@/shared/data/queryFilters';
import type { GridFilters } from '@/ui/composites/grid/gridFilters';

const pipelineQueryFilterFields = new Set([
  'id',
  'projectId',
  'organisationId',
  'createdById',
  'provider',
  'pipelineKey',
  'name',
  'defaultBranch',
  'pipelineUrl',
  'latestRunStatus',
  'executionFrequencyPerDay',
  'executionAverageDurationMs',
  'executionPassRate',
  'executionFrequencyPerDayDelta',
  'executionAverageDurationMsDelta',
  'executionPassRateDelta',
  'executionFlakeScoreDelta',
  'executionMttfSecondsDelta',
  'executionFlakeScore',
  'executionMttfSeconds',
  'tags',
]);

const pipelineRunSummaryQueryFilterFields = new Set([
  'id',
  'projectId',
  'pipelineId',
  'organisationId',
  'createdById',
  'buildKey',
  'pipelineName',
  'status',
  'lifecycleState',
  'conclusion',
  'displayStatus',
  'startedAt',
  'finishedAt',
  'tags',
]);

const pipelineStageQueryFilterFields = new Set([
  'id',
  'projectId',
  'pipelineId',
  'pipelineExecutionId',
  'pipelineName',
  'stageName',
  'organisationId',
  'createdById',
  'status',
  'tags',
  'startedAt',
  'timestamp',
  'finishedAt',
]);

export const filterPipelineQueryFields = (filters: GridFilters): GridFilters =>
  filterSupportedQueryFields(filters, pipelineQueryFilterFields);

export const filterPipelineRunSummaryQueryFields = (filters: GridFilters): GridFilters =>
  filterSupportedQueryFields(filters, pipelineRunSummaryQueryFilterFields);

export const filterPipelineStageQueryFields = (filters: GridFilters): GridFilters =>
  filterSupportedQueryFields(filters, pipelineStageQueryFilterFields);
